
import * as ko from "knockout";
import {ReportViewer} from "../common/reportViewer";
import * as ReportData from "../data/reportData";
import { IController } from "../interfaces/controller";
import * as Data from "../interfaces/data";

interface IViewModel {
    reports: KnockoutObservableArray<ReportData.IReportDefinition>;
}

export class ViewReportsController implements IController {
    private reportViewer: ReportViewer;
    private container: JQuery;
    private viewModel: IViewModel;
    private treeDataSource: ReportData.IReportTreeItem[];
    private treeView: any;

    constructor() {
        this.viewModel = {
            reports: ko.observableArray<ReportData.IReportDefinition>(),
        };

        this.reportViewer = new ReportViewer();
    }

    public render(container: JQuery): JQueryPromise<any> {
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();
        const me: ViewReportsController = this;
        this.container = container;

        me.treeView = $(me.container).find(".reportsTree").kendoTreeView({
            change(e: kendo.ui.TreeViewEvent): void {
                const dataItem = me.treeView.dataItem(me.treeView.select()) as ReportData.IReportTreeItem;
                if (dataItem && dataItem.report) {
                    me.reportViewer.loadReport(dataItem.report.ID);
                }
            },
        }).data("kendoTreeView");

        // single-click expand/collapse folders:
        $(".reportsTree").on("click", ".k-in", (e: any) => {
            me.treeView.toggle($(e.target).closest(".k-item"));
        });

        ko.applyBindings(this.viewModel, container[0]);

        this.reportViewer.render(this.container.find(".reportContainer"));

        deferred.resolve();
        return deferred.promise();
    }

    public load(params: any[]): JQueryPromise<any> {
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

        this.loadReports(deferred);

        return deferred.promise();
    }

    public refresh() {
        this.loadReports();
    }

    public appRouterID(params: any): string {
        return "View Reports";
    }

    public title(): string {
        return "View Reports";
    }

    public subTitle(): string {
        return "";
    }

    public haveFieldsChanged(): boolean {
        return false;
    }

    private loadReports(deferred?: JQuery.Deferred<any, any, any>) {

        ReportData.GetAllReports().then((response: Data.IResponse<ReportData.IReportDefinition[]>) => {
            const runnableReports = response.Payload.filter((report: ReportData.IReportDefinition): boolean => {
                return (report.FileKey !== null && report.IsActive === true);
            });
            this.viewModel.reports(runnableReports);

            this.treeDataSource = ReportData.CreateReportTreeDataSource(runnableReports);
            this.treeView.setDataSource(this.treeDataSource);

            if (deferred) {
                deferred.resolve();
            }
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/controllers/viewReports.ts